import React, { Component } from 'react'

import { getStorageItem} from "../../utilities/FrontFunctions/AoxFrontFunctions"

import '../../assets/css/0020_objects/1060_obj_toast.css'

class ObjNoticeAppMobile extends Component {
	constructor(props) {
		super(props)

		this.state = {
			isVisible: false
		}

		this.showTimer = null
		this.handleCloseToast = this.handleCloseToast.bind(this)
	}

	componentDidMount() {
        if(!getStorageItem('dontShowAgainObjNoticeAppMobile')){
            this.showTimer = setTimeout(() => {
                this.setState({ isVisible: true })
            }, 2000)
        }
	}

	componentWillUnmount() {
		clearTimeout(this.showTimer)
	}

	handleCloseToast() {
		this.setState({ isVisible: false })
        localStorage.setItem('dontShowAgainObjNoticeAppMobile', 'true')
	}

	render() {
		const { isVisible } = this.state

		return (
			<div className={`obj_toast toast_notice-app ${isVisible ? 'is-visible' : ''}`} data-position="bottom" >
				<div className="ctn_toast">
					<div className="obj_text">
						<div className="ctn_text">
							<p className="t_title">Découvrez le site Partner <br/>Academy sur l'application mobile</p>

							<ul className="obj_list_items">
								<li className="item">
									<a className="obj_button_apple" href="https://apps.apple.com/fr/app/partner-academy/id1603421693" target="_blank">
										<img src={require("../../assets/images/i_appstore_fr.svg")} alt="Télécharger dans l'App Store"/>
									</a>
								</li>
								<li className="item">
									<a className="obj_button_google" href="https://play.google.com/store/apps/details?id=com.loreal.MyFormation" target="_blank">
										<img src={require("../../assets/images/i_gstore_fr.svg")} alt="Disponible sur Google Play"/>
									</a>
								</li>
							</ul>

							<button
								type="button"
								className="obj_btn btn-link"
								onClick={this.handleCloseToast}
								aria-label="Ne plus me demander"
							>
								Ne plus me demander
							</button>
						</div>
					</div>
				</div>

				<div className="ctn_toast-aside">
					<button
						type="button"
						className="obj_toast-close"
						onClick={this.handleCloseToast}
						aria-label="Fermer"
					>
						<svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
							<path
								d="M0.75 10.75L5.75 5.74999M5.75 5.74999L0.75 0.767316M5.75 5.74999L10.75 0.75M5.75 5.74999L10.75 10.7327"
								strokeWidth="1.5"
								strokeLinecap="round"
								strokeLinejoin="round"
							/>
						</svg>
					</button>
				</div>
			</div>
		)
	}
}

export default ObjNoticeAppMobile